
function SdInputDateController(TranslationService) {
    var ctrl = this;
    ctrl.placeholder = '';

    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.$onInit = function () {

    };

    ctrl.inputChanged = function () {
        //console.log('dateChanged');
        ctrl.onChanged();
    };

    ctrl.clear = function () {
        ctrl.model = null;
        ctrl.onChanged();
    };
}

SdInputDateController.$inject = ['TranslationService'];

seedWebApp.component('sdInputDate', {
    controller: SdInputDateController,
    bindings: {
        name: '@',
        options: '<',           // Modelo (Key, Value)
        label: '<',             // Label do input
        model: '=',             // Modelo à ser alterado
        disabled: '<',          // Define se campo está desabilitado para edição
        placeholder: '<',
        filterString: '<',
        onChanged: '&'
    },
    templateUrl: '/SPA/components/sd-input-date.html' + seedWebApp.buildVersion
});